export function getConversionTypeFriendlyName(conversionType: string) {
  switch (conversionType) {
    case 'Web':
      return 'Form';
    case 'InboundCall':
      return 'Phone Call';
    default:
      return conversionType;
  }
}
